import App from '../app'
import Vue from 'vue'

new Vue({
  extends: App
})
